class IntercomCtrl
  constructor: ->
    @init()

  finish: =>
    window.Intercom 'shutdown'

  start: (params) =>
    window.Intercom 'boot',
      app_id: process.env.INTERCOM_API_KEY
      name: params.current_user.name
      email: params.current_user.email
      created_at: (new Date().getTime() / 1000)
      job_title: params.current_user.roleDescription()
      new_reev: false
      company:
        id: params.current_company.id
        name: params.current_company.name
      user_hash: params.hash

    setTimeout (->
      jQuery('.intercom-launcher').addClass('hide-intercom') if window != window.parent
      return
    ), 2000

  init: ->
    d = document
    w = window
    ic = w.Intercom

    s = d.createElement('script')
    s.setAttribute('src', 'https://widget.intercom.io/widget/s2621u0d')
    s.setAttribute('async', true)
    d.head.appendChild(s)

    i = ->
      i.c arguments
      return

    i.q = []

    i.c = (args) ->
      i.q.push args
      return

    w.Intercom = i

  @trackEvent: (event_name, event_meta_data) ->
    window.Intercom 'trackEvent', event_name, event_meta_data

  @trackEventMetadata: (event_name, metadata_list, old_object, new_object) ->
    event_meta_data = {}
    for metadata in metadata_list
      value = if metadata.value
        metadata.value
      else if metadata.function
        @[metadata.function](old_object, new_object, metadata.attribute)
      event_meta_data[metadata.key] = value

    @trackEvent(event_name, event_meta_data)

  @htmlImgTagQuantityDiff: (old_object, new_object, attribute) ->
      "#{jQuery('<div/>').html(old_object[attribute]).find('img').length} -> #{jQuery('<div/>').html(new_object[attribute]).find('img').length}"

  @htmlImgTagQuantity: (old_object, new_object, attribute) ->
    "#{jQuery('<div/>').html(new_object[attribute]).find('img').length}"

  @htmlATagQuantityDiff: (old_object, new_object, attribute) ->
    "#{jQuery('<div/>').html(old_object[attribute]).find('a').length} -> #{jQuery('<div/>').html(new_object[attribute]).find('a').length}"

  @htmlATagQuantity: (old_object, new_object, attribute) ->
    "#{jQuery('<div/>').html(new_object[attribute]).find('a').length}"

  @changedFromTo: (old_object, new_object, attribute) ->
    "#{old_object[attribute]} -> #{new_object[attribute]}"

  @isChanged: (old_object, new_object, attribute) ->
    if old_object[attribute] != new_object[attribute] then 'Sim' else 'Não'

module.exports = IntercomCtrl



// WEBPACK FOOTER //
// ./src/libraries/intercom.coffee